import { isPlatformServer } from '@angular/common';
import { Directive, EventEmitter, HostListener, Inject, OnDestroy, Output, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { Rect } from 'src/app/classes/rect.class';
import { ScrollService } from 'src/app/services/scroll.service';
export type SwipeDirection = 'up' | 'down' | 'left' | 'right';

@Directive({
  selector: '[appSwipe]',
  standalone: true,
})
export class SwipeDirective implements OnDestroy {
  @Output() onSwipe: EventEmitter<SwipeDirection> = new EventEmitter();
  @HostListener('touchstart', ['$event']) touchStart(event: TouchEvent) {
    if (!event.changedTouches[0]) return;
    this.pos = Rect.fromTouch(event.changedTouches[0]);
    this.time = Date.now();
    this.scrolled = false;
  }
  @HostListener('touchend', ['$event']) touchEnd(event: TouchEvent) {
    if (this.scrolled) return;
    if (!this.pos) return;
    if (!event.changedTouches[0]) return;
    const moved = Rect.fromTouch(event.changedTouches[0]).subtract(this.pos);
    const duration = Date.now() - this.time;
    if (duration > 700) return;
    const axis = Math.abs(moved.x) > Math.abs(moved.y) ? 'x' : 'y';
    if (Math.abs(moved[axis]) < 30) return;
    const direction = axis === 'x' ? (moved[axis] > 0 ? 'left' : 'right') : moved[axis] > 0 ? 'down' : 'up';
    this.onSwipe.emit(direction);
  }

  pos: Rect;
  time: number;
  scrollSub: Subscription;
  scrolled = false;

  constructor(private scrollService: ScrollService, @Inject(PLATFORM_ID) private platformId: string) {
    if (isPlatformServer(this.platformId)) return;
    this.scrollSub = this.scrollService.onScroll.subscribe((event: Event) => {
      if (!event) return;
      const target = <HTMLElement>event.target;
      if (target?.toString().includes('HTMLDocument')) return;
      if (target.scrollTop < 0) return;
      this.scrolled = true;
    });
  }

  ngOnDestroy() {
    this.scrollSub?.unsubscribe();
  }
}
